// When should a service-worker controllerchange reload the page?
//
// The Workbox SW (scripts/generate-sw.js) uses skipWaiting + clientsClaim. Reloading when a NEW
// SW replaces an OLD one is intentional (PR #6/#7): otherwise the tab keeps running the previous
// precached chunks (FOR SALE $0 / min bid $11.001). But clientsClaim also fires controllerchange
// on the very first install, when nothing was controlling the page and it is already running the
// network (latest) build. Reloading then re-ran /verify-email about 7-9s after first open and sent
// a second verify POST (QA r15 FAIL on fix/verify-email-once).
//
// hadController must be read once at page load, before the SW registers.

const NO_RELOAD_PATHS = [/^\/verify-email\/?$/, /^\/reset-password\/?$/];

export function isNoReloadPath(pathname) {
  return NO_RELOAD_PATHS.some((re) => re.test(String(pathname || '')));
}

export function shouldReloadOnControllerChange({ hadController, pathname, alreadyRefreshing }) {
  if (alreadyRefreshing) return false;
  if (!hadController) return false;     // first install: nothing stale to replace
  if (isNoReloadPath(pathname)) return false; // one-shot token pages: never re-run them
  return true;                          // old SW -> new SW: swap out stale chunks (PR #6/#7)
}
